import {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ensureWebAdminLocaleStrings, ensureWebPlayLocaleStrings} from 'actions/commonActions';
import getTranslateFunc from 'utils/getTranslateFunc';

// The web bootstrap initially carries only the UI locale. A MathRods language
// version needs its own catalog, without changing the author's UI language.
export default function useMathRodsTranslate(locale, fallback) {
  const dispatch=useDispatch();
  const strings=useSelector(state=>state.common.strings);
  useEffect(()=>{
    if(!locale)return;
    Promise.all([
      dispatch(ensureWebAdminLocaleStrings(locale)),
      dispatch(ensureWebPlayLocaleStrings(locale)),
    ]).catch(error=>console.warn('MathRods could not load its language strings',error));
  },[dispatch,locale]);
  return useMemo(()=>locale&&strings?getTranslateFunc(strings,locale):fallback,[strings,locale,fallback]);
}
